import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { navigate, useLocation } from "@reach/router";
import useSWR from "swr";
import { Facebook as FacebookLoader } from "react-content-loader";
import { Textfit } from "react-textfit";

import fetcher from "libs/swr";
import { useAppContext } from "libs/contextLib";

import BigSpinner from "components/BigSpinner";
import CourseListItem from "components/CourseListItem";
import GenericError from "components/GenericError";
import { NoCourses } from "components/GenericImage";
import { TEACHER_URLS, STUDENT_URLS } from "constants/urls";

import "./course-list.scss";

function CourseList(props) {
  const { authenticatedUser, authenticateUser } = useAppContext();
  const isTeachDomain = props && props.for === "teacher";
  const location = useLocation();

  const courseListURL = isTeachDomain
    ? TEACHER_URLS.COURSE_LIST
    : STUDENT_URLS.COURSE_LIST;
  const { data, error } = useSWR(courseListURL, fetcher);

  useEffect(() => {
    if (isTeachDomain && authenticatedUser === null) {
      navigate("/login?redirect=" + location.pathname);
    }
  });

  if (isTeachDomain) {
    if (authenticatedUser === false) {
      return <BigSpinner />;
    } else if (authenticatedUser === null) {
      return null;
    }
  }

  if (!data && !error) {
    return <FacebookLoader foregroundColor="#F6C6C6" />;
  } else if (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      authenticateUser(null);
    }
    // TODO: Show error code specific errors:
    // - Not authorized on 403
    // - Try again on timeout

    return (
      <Row>
        <Col xs={10} md={8} style={{ height: "50vh" }}>
          <GenericError />
        </Col>
      </Row>
    );
  } else if (!Array.isArray(data.results) || !data.results.length) {
    return (
      <Row>
        <Col xs="auto" style={{ height: "50vh" }} className="no-results">
          <NoCourses />
          <div className="help-text">
            <Textfit mode="single">No courses are running currently :(</Textfit>
          </div>
        </Col>
      </Row>
    );
  } else {
    return data.results.map((item) =>
      !item.is_subscribed ? (
        <CourseListItem course={item} key={item.id} for={props.for} />
      ) : null
    );
  }
}

export default CourseList;
